module.exports = __webpack_public_path__ + "img/202502_02.b4a147f0.jpg";